import React, {useCallback, useEffect, useState} from 'react'
import './modal-style.css'
import {changeModalVisibility} from '../../../../setup/slices/ModalSlice'
import {useDispatch} from 'react-redux'
import {AnaVezneCustomersCall, UpdateCustomerStore} from '../apis/ApiCall'

type Props = {
  customer: any
  stores: any
  setCustomers: React.Dispatch<React.SetStateAction<any>>
  setIsLoading: React.Dispatch<React.SetStateAction<any>>
}

const VezneModalCard: React.FC<Props> = ({customer, stores, setCustomers, setIsLoading}) => {
  const [selectedStore, setSelectedStore] = useState<string>('Seçim')
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)

  const dispatch = useDispatch()

  const escFunction = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        dispatch(changeModalVisibility(false))
      }
    },
    [dispatch]
  )

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  const handleUpdateSubmit = async (
    customerReference: string,
    storeId: string,
    storeDesc: string
  ) => {
    let newStoreDesc = storeDesc.split(' ')
    newStoreDesc.shift()

    setButtonDisabled(true)
    await UpdateCustomerStore(customerReference, storeId, newStoreDesc.join(' '))
    setTimeout(() => {
      setButtonDisabled(false)
    }, 1000)
    dispatch(changeModalVisibility(false))
    AnaVezneCustomersCall(setCustomers, setIsLoading)
  }
  console.log('315269', stores, customer)
  return (
    <div className='custom-modal bd-example-modal-lg' id='anavezne-modal' style={{zIndex: 3000}}>
      <div className='modal-dialog modal-dialog-scrollable modal-lg' role='document'>
        <div className='modal-content' style={{marginTop: "25%"}}>
          <div className='modal-header'>
            <h2 className='modal-title' id='exampleModalLongTitle'>
              Müşteri Kartı
            </h2>
            <button
              type='button'
              className=' btn btn-danger close w-30px h-30px p-0'
              onClick={() => dispatch(changeModalVisibility(false))}
            >
              <span className='fw-bolder fs-2'>&times;</span>
            </button>
          </div>
          <div className='modal-body d-flex row justify-content-center'>
            <div className='row mt-2'>
              <div className='col-4 text-end fw-bolder fs-6'>Müşteri Adı</div>
              <div className='col-1 fw-bolder fs-6'>:</div>
              <div className='col-6 fw-bolder fs-4'>{customer?.CustName}</div>
            </div>
            <div className='row mt-2'>
              <div className='col-4 text-end fw-bolder fs-6'>Müşteri Kodu</div>
              <div className='col-1 fw-bolder fs-6'>:</div>
              <div className='col-6 fw-bolder fs-4'>{customer?.Customerreference}</div>
            </div>
            <div className='row mt-2'>
              <div className='col-4 text-end fw-bolder fs-6'>VKN</div>
              <div className='col-1 fw-bolder fs-6'>:</div>
              <div className='col-6 fw-bolder fs-4'>{customer?.VergiNo}</div>
            </div>
            <div className='row mt-2'>
              <div className='col-4 text-end fw-bolder fs-6'>Tanımlı Ana Vezne</div>
              <div className='col-1 fw-bolder fs-6'>:</div>
              <div className='col-6 fw-bolder fs-4'>
                <select
                  name='vezne-sec'
                  id='vezne-select'
                  onChange={(e) => setSelectedStore(e.target.value)}
                  className='bg-light-primary text-gray-700'
                >
                  <option value='Seçim'>Seçim Yapınız...</option>
                  {stores.Detail.map((store: any, index: number) => (
                    <option
                      value={`${store.CustomerReference} ${store.DisplayName}`}
                      selected={
                        // customer &&
                        // customer.StoreId &&
                        // customer.StoreId.toString() === store.CustomerReference
                        store.customerreference
                      }
                      key={index}
                    >
                      {store.CustomerReference} - {store.DisplayName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className='modal-footer'>
            <button
              type='button'
              className='btn btn-danger'
              data-dismiss='modal'
              onClick={() => dispatch(changeModalVisibility(false))}
            >
              İptal
            </button>
            <button
              type='button'
              className={`btn ${
                selectedStore === 'Seçim' ? 'btn-secondary disabled' : 'btn-success '
              }`}
              onClick={() =>
                handleUpdateSubmit(
                  customer.Customerreference,
                  selectedStore.split(' ')[0],
                  selectedStore
                )
              }
              disabled={selectedStore === 'Seçim' || buttonDisabled}
            >
              Değişiklikleri Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VezneModalCard
